// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"bb9091d3","141":"bb9091d3","382":"e552c8c9","603":"bb9091d3","631":"0f36b87f","640":"ae2f0949","768":"e552c8c9","913":"e552c8c9"}[chunkId] + ".chunk.css";
};